// extracted by mini-css-extract-plugin
export var datasourceListObject = "datasource-list-module--datasource-list-object--jJMwg";
export var datasourceType = "datasource-list-module--datasource-type--aqaRm";
export var datasourcesDsName = "datasource-list-module--datasources-ds-name--9rkLe";
export var datasourcesAccordionSummary = "datasource-list-module--datasources-accordion-summary--f8+Aa";